export const formatPercent = (rate: number) =>
  `${Number((rate * 100).toFixed(2))}%`
